import React from 'react';
import { MainPageLayout } from '../layout/MainPageLayout';
import { DeviceSetupDiv } from '../component/device-setup/DeviceSetupDiv';

export const DeviceSetupPage = () => (
  <MainPageLayout elementCentr={<DeviceSetupDiv />} />
);
